import { PropsWithChildren } from 'react';
import { cn } from '@antimatterhq/ui/lib/utils';

type Color = 'primary' | 'secondary' | 'info' | 'error' | 'success' | 'warning';

export type ParagraphProps = {
  color?: Color;
} & React.HTMLAttributes<HTMLParagraphElement>;

export default function Paragraph({
  color,
  children,
  className,
  ...props
}: PropsWithChildren & ParagraphProps) {
  return (
    <p
      className={cn(
        'text-sm',
        (!color || color === 'primary') && 'text-grey-800 dark:text-grey-100',
        color === 'secondary' && 'text-grey-500 dark:text-grey-350',
        color === 'info' && 'text-blue-600 dark:text-blue-400',
        color === 'error' && 'text-red-600 dark:text-red-500',
        color === 'success' && 'text-green-600 dark:text-green-500',
        color === 'warning' && 'text-yellow-600 dark:text-yellow-500',
        className,
      )}
      {...props}
    >
      {children}
    </p>
  );
}
